import "./styles.sass";
import { ROUTE_LOGIN } from "../../route";
import assets from "../../assets";
import useHandler from "./handler";

export const CheckMail = () => {
  const {
    navigete,
    setEmail,
    onResetPassword,
    isForgot,
    email,
    error,
    isLoading,
  } = useHandler();
  const { errEmail } = error;

  return (
    <section className="check_mail">
      <section className="check_mail_card">
        <section className="check_mail_icon">
          <img src={assets.ic_check_mail} alt="ic_check_mail" />
        </section>

        <h2>Check your email</h2>

        <p>
          A temporary password has been sent to your registered email address.
          Use it to log in and access your account.
        </p>

        {isForgot && (
          <section className="check_login_form_group">
            <label>Email address</label>
            <input
              type="email"
              placeholder="you@example.com"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            {errEmail && <p>{errEmail}</p>}
          </section>
        )}

        {isForgot && (
          <section
            className={`check_reset_password_btn${isLoading ? " is_disabled" : ""}`}
            onClick={onResetPassword}
            aria-disabled={isLoading}
          >
            {isLoading ? (
              <div className="loader"></div>
            ) : (
              <h4>Resend Password</h4>
            )}
          </section>
        )}

        <section
          className="check_mail_btn"
          onClick={() => navigete(ROUTE_LOGIN)}
        >
          <h5>Log In Now →</h5>
        </section>

        <section className="check_mail_footer">
          Didn't receive the email?
          <span>
            {" "}
            <a href={`mailto:${email}`}>Check your spam folder </a>
          </span>
        </section>
      </section>
    </section>
  );
};
